export default __webpack_public_path__ + "static/cap2-8afa714b6feae17128b27ee5615c2c3e.png";